export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE'
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const ADD_CART = 'ADD_CART'
export const GET_CART_REQUEST_SUCESSS = 'GET_CART_REQUEST_SUCESSS'
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS'
export const GET_ALL_ORDER_SUCCESS = 'GET_ALL_ORDER_SUCCESS'
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS'
export const SET_LOGGEDIN_USER = 'SET_LOGGEDIN_USER'
export const GET_ALL_CUSTOMERS_SUCCESS = 'GET_ALL_CUSTOMERS_SUCCESS'
export const GET_CUSTOMER_DETAIL_SUCCESS = 'GET_CUSTOMER_DETAIL_SUCCESS'
export const SET_STORE_ADDRESS = 'SET_STORE_ADDRESS'
export const GET_DEVICE_INVENTORY = 'GET_DEVICE_INVENTORY'
export const GET_SIM_INVENTORY = 'GET_SIM_INVENTORY'
export const GET_ACTIVE_LINES_INVENTORY = 'GET_ACTIVE_LINES_INVENTORY'
export const GET_AMAZON_ORDERS = 'GET_AMAZON_ORDERS'
export const GET_DEVICE_ACTIVATE_REQUESTS = 'GET_DEVICE_ACTIVATE_REQUESTS'
export const GET_SIM_ACTIVATE_REQUESTS = 'GET_SIM_ACTIVATE_REQUESTS'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_RECURRING_PROFILE = 'SET_RECURRING_PROFILE'
export const SET_DISCOUNTS = 'SET_DISCOUNTS'
export const GET_AUTO_RENEWALS = 'GET_AUTO_RENEWALS'
export const GET_AUTO_RENEWAL_ORDERS = 'GET_AUTO_RENEWAL_ORDERS'


// WEBPACK FOOTER //
// ./src/ducks/actions/types.js